<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Kỳ' }}
                </div>
                <div class="">
                  <!-- <CalendarRange v-model="searchParams.date" mode="date" /> -->
                  <el-date-picker
                    v-model="searchParams.monthRange"
                    type="month"
                    format="MM/yyyy"
                    :clearable="false"
                    start-placeholder="Tháng bắt đầu"
                    end-placeholder="Tháng kết thúc"
                  >
                    <template #range-separator>
                      <div class="date-divide"></div>
                    </template>
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label label-checkbox">
                  {{ 'Công ty/Đại lý' }}
                </div>
                <div>
                  <select-with-search-table
                    index-field="id"
                    :dropdown-width="560"
                    :search-fields="['code', 'name']"
                    :selected-index-field-value="searchParams.agentId"
                    :value="searchParams.agentId"
                    :multiple="false"
                    :rows="agencyOptions"
                    :columns="agencyOptionsCols"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectAgency"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{ `${selectedData?.name || ''}` }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <!-- <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div
              class="das-form-title"
              style="display: flex; flex-direction: column; gap: 0.5rem"
            >
              <span class="main-title">
                {{ `Báo cáo chi tiết công nợ` }}
              </span>
              <div>
                Đại lý: <span style="font-weight: bold">{{ agentName }}</span>
              </div>
              <div v-if="agent?.business_person">
                Nhân viên kinh doanh theo chuỗi:
                <span style="font-weight: bold">
                  {{ agent?.business_person }}
                </span>
              </div>
              <div>
                Kỳ:
                <span style="font-weight: bold"
                  >Tháng
                  <template v-if="monthFrom !== monthTo">
                    {{ monthFrom }}
                    -
                    {{ monthTo }}
                  </template>
                  <template v-else>
                    {{ monthFrom }}
                  </template></span
                >
              </div>
            </div>

            <DownloadBtn
              @openNoteDialog="dialogNoteVisible = true"
              @exportExcel="downloadExcel"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :auto-size-cell="true"
              :row-multi-select-with-click="true"
              :columns="columns"
              :rows="rows"
              :get-row-class="getRowClass"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :style="
                rows.length > 0
                  ? `height: auto !important`
                  : 'min-height: 200px'
              "
              :suppress-row-transform="true"
              :pinned-bottom-row-data="pinnedBottomRowData"
              @selectionChanged="onSelectionChanged"
            />
          </div>

          <div class="button-containers mb-0">
            <button
              v-if="checkAuthorPaymentDebt"
              :disabled="
                selectedRows.length <= 0 ||
                selectedRows.some(item => item?.debt <= 0)
              "
              class="btn primary small"
              @click="onOpenPaymentDialog"
            >
              {{ 'Thanh toán' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="content-box mt-10">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div
              class="das-form-title"
              style="display: flex; flex-direction: column; gap: 0.5rem"
            >
              <span class="main-title">
                {{ `Phát sinh giảm` }}
              </span>
            </div>
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :auto-size-cell="true"
              :columns="decreaseCols"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :rows="decreaseRows"
              class="agGrid"
              :row-multi-select-with-click="true"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Ngày: Ngày phát sinh công nợ</li>
            <li>Recode: Mã đặt phòng có phát sinh thanh toán công nợ</li>
            <li>
              Dịch vụ sản phẩm: Danh sách các sản phẩm, dịch vụ thuộc hóa đơn
              được thanh toán bằng công nợ
            </li>
            <li>Hóa đơn: Số hóa đơn được thanh toán bằng công nợ</li>
            <li>Phát sinh tăng: Số tiền phát sinh của hóa đơn</li>
            <li>Phát sinh giảm: Số tiền công ty đại lý đã thanh toán</li>
            <li>Dư nợ = Phát sinh tăng - Phát sinh giảm</li>
            <li>Kế toán: Họ tên kế toán thực hiện đẩy công nợ</li>
            <li>Số ngày nợ: Số ngày hóa đơn đã nợ</li>
            <li>
              Số ngày đến hạn: Số ngày còn lại để thanh toán = ngày phát sinh +
              Số ngày được nợ - Số ngày nợ
            </li>
            <li>Hình thức thanh toán: Phương thức chuyển tiền thanh toán</li>
            <li>Ghi chú: Ghi chú của công nợ</li>
          </ul>
        </div>
      </div>
    </NoteDialog>

    <PaymentDialog
      v-model="dialogPaymentVisible"
      :data="data"
      @refresh="onRefresh"
    />
  </div>
</template>

<script>
/* eslint-disable */
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
// import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import PaymentDialog from './debtReport/PaymentDialog.vue'
import { ViewInvoiceCellRenderDebtReport } from '@/utils/cellRenders'

import {
  getDebtDetailReport,
  getDebtDetailReportExcel
} from '@/api/report_service/datntReport'
import { getAllHotel } from '@/api/hotel'
import {
  getAgentByIdApi,
  getAgentSimpleListApi
} from '@/api/configuration/profile/agent'
import { formatVND } from '@/utils/commonUtils'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'
import { checkAuthorized } from '@/utils/helper'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    DownloadBtn,
    NoteDialog,
    PaymentDialog,
    ViewInvoiceCellRenderDebtReport
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        // autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      searchParams: {
        // date: {
        // start:
        //   this.$route.query?.start ||
        //   this.$moment().startOf('month').format('YYYY-MM-DD'),
        // end: this.$route.query?.end || this.$moment().format('YYYY-MM-DD')
        // },
        // monthRange: [
        //   this.$route.query?.start
        //     ? this.$moment(this.$route.query?.start, 'YYYY-MM-DD')
        //     : this.$moment().startOf('month'),
        //   this.$route.query?.end
        //     ? this.$moment(this.$route.query?.end, 'YYYY-MM-DD')
        //     : this.$moment().startOf('month')
        // ],
        monthRange: this.$route.query?.start
          ? this.$moment(this.$route.query?.start, 'YYYY-MM-DD')
          : this.$moment().startOf('month'),
        agentId: +this.$route.query?.agentId || null,
        hotelIdList: null
      },
      defaultSearchParams: {
        monthRange: this.$route.query?.start
          ? this.$moment(this.$route.query?.start, 'YYYY-MM-DD')
          : this.$moment().startOf('month'),
        agentId: +this.$route.query?.agentId || null,
        hotelIdList: null
      },

      // data for search
      hotelList: [],
      agencyOptions: [],
      agencyOptionsCols: [
        {
          headerName: this.$t('grid.column.agencyCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          flex: 2,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.agencyName'),
          field: 'name',
          tooltipField: 'name',
          // cellClass: 'grid-cell-centered',
          flex: 3,
          sortable: false
        }
      ],

      // grid
      columns: [
        {
          headerdesc: '',
          minWidth: 50,
          maxWidth: 50,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false,
          sortable: false
        },
        {
          headerName: 'Ngày',
          field: 'date',
          tooltipField: 'date',
          rowSpan: params => window.rowSpan(params),
          cellStyle: params => window.cellStyle(params)
        },
        {
          headerName: 'Recode',
          field: 'recode',
          tooltipField: 'recode',
          rowSpan: params => window.rowSpan(params),
          cellStyle: params => window.cellStyle(params),
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Dịch vụ sản phẩm',
          field: 'transaction_type_nm',
          tooltipField: 'transaction_type_nm',
          minWidth: 100
        },
        {
          headerName: 'Hóa đơn',
          field: 'invoice_num',
          tooltipField: 'invoice_num',
          cellRenderer: 'ViewInvoiceCellRenderDebtReport',
          minWidth: 150
        },
        {
          headerName: 'Phát sinh tăng',
          field: 'increase',
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.increase, null),
          tooltipValueGetter: params => formatVND(params.data.increase, null),
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Phát sinh giảm',
          field: 'decrease',
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.decrease, null),
          tooltipValueGetter: params => formatVND(params.data.decrease, null),
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Dư nợ',
          field: 'debt',
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.debt, null),
          tooltipValueGetter: params => formatVND(params.data.debt, null),
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Kế toán',
          field: 'full_name',
          tooltipField: 'full_name',
          cellClass: 'ag-cell-left'
        },
        {
          headerName: 'Số ngày nợ',
          field: 'num_of_day_debt',
          tooltipField: 'full_name'
        },
        {
          headerName: 'Số ngày đến hạn',
          field: 'num_of_day_due',
          tooltipField: 'num_of_day_due'
        }
      ],
      rows: [],
      selectedRows: [],
      pinnedBottomRowData: [],

      // dialog
      dialogNoteVisible: false,
      dialogPaymentVisible: false,
      data: null,

      // decrease section
      decreaseCols: [
        {
          headerName: 'Ngày',
          field: 'date',
          minWidth: 120,
          maxWidth: 120,
          tooltipField: 'date'
        },
        {
          headerName: 'Dịch vụ sản phẩm',
          field: 'transaction_type_nm',
          tooltipField: 'transaction_type_nm',
          minWidth: 120,
          flex: 1
        },
        {
          headerName: 'Recode',
          field: 'recode',
          minWidth: 100,
          maxWidth: 120,
          tooltipField: 'recode'
        },
        {
          headerName: 'Hóa đơn',
          field: 'invoice_num',
          minWidth: 100,
          maxWidth: 150,

          tooltipField: 'invoice_num'
        },

        {
          headerName: 'Phát sinh giảm',
          field: 'decrease',
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.decrease, null),
          tooltipValueGetter: params => formatVND(params.data.decrease, null),
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Dư nợ',
          field: 'debt',
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.debt, null),
          tooltipValueGetter: params => formatVND(params.data.debt, null),
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Kế toán',
          field: 'full_name',
          minWidth: 120,
          tooltipField: 'full_name',
          fleX: 1
        },
        {
          headerName: 'Hình thức thanh toán',
          field: 'payment_method_nm',
          tooltipField: 'payment_method_nm',
          minWidth: 140,
          maxWidth: 140
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          minWidth: 120,
          tooltipField: 'note'
        }
      ],
      decreaseRows: [],

      agent: null,

      // authorize
      checkAuthorPaymentDebt: false,

      monthFrom: null,
      monthTo: null,
      agentName: null
    }
  },

  // watch: {
  //   'searchParams.monthRange'(nv, ov) {
  //     this.getAgent()
  //   }
  // },

  async mounted() {
    window.rowSpan = params => {
      if (params.data?.row_class === 'firstRow') {
        return params.data?.count_rows
      } else {
        return 1
      }
    }
    window.cellStyle = params => {
      if (
        params.data?.row_class === 'firstRow' &&
        params.data?.count_rows > 1
      ) {
        return {
          top: '0',
          'background-color': 'white',
          borderBottom: `1px solid rgba(189, 195, 199, 0.58)`,
          borderRight: `1px solid rgba(189, 195, 199, 0.58)`,
          borderLeft:
            params.colDef.field === 'recode' // dirty code
              ? 'none'
              : `1px solid rgba(189, 195, 199, 0.58)`,
          height: `calc(${params.data?.count_rows} * ${DEFAULT_GRID_ROW_HEIGHT}px)`,
          display: 'flex',
          alignItems: 'center'
        }
      }
      return null
    }

    // if (!this.searchParams.agentId) {
    //   this.$message({
    //     type: 'error',
    //     message: this.$t('errorMsg.agentIdIsRequired')
    //   })
    //   this.$router.push('/report/cfo_report/synthetic_debt_report')
    // }
    // await this.getListHotel()
    this.agencyOptions = await this.getAgent()
    if (!this.searchParams.agentId) {
      const debtAgentcy = await this.getAgent(true)
      this.searchParams.agentId = debtAgentcy[0]?.id
      this.defaultSearchParams.agentId = debtAgentcy[0]?.id
    }

    await this.getAgentById(this.searchParams.agentId)
    await this.fnGetDebtDetailReport()

    this.checkAuthorPaymentDebt = checkAuthorized('PAYMENT_DEBT')
  },

  methods: {
    async onSearch() {
      if (this.searchParams.agentId) {
        await this.getAgentById(this.searchParams.agentId)
        await this.fnGetDebtDetailReport()
      }
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.onSearch()
    },

    getRowClass(params) {
      if (
        params.data?.num_of_day_due != null &&
        params.data?.num_of_day_due <= 1
      ) {
        return 'debt-report-row-' + 'warning'
      }
      return ''
    },

    onSelectionChanged(selectedRows) {
      this.selectedRows = selectedRows
    },
    onOpenPaymentDialog() {
      this.data = {
        agentNm: this.agent?.name,
        sourceNm: this.agent?.source,
        invoices: this.selectedRows
      }
      this.dialogPaymentVisible = true
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },

    onRefresh() {
      if (this.searchParams.agentId) {
        this.fnGetDebtDetailReport()
      }
    },

    async onSelectAgency(val) {
      this.searchParams.agentId = val.id ?? null
      // this.agent = val
      // if (val?.id) {
      //   await this.getAgentById(this.searchParams.agentId)
      // }
    },

    // handle call api
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    // async getListAgent() {
    //   const res = await getAgentSimpleListApi()
    //   this.agencyOptions = res.data
    // },
    async getAgent(isDebt = null) {
      const res = await getAgentSimpleListApi({
        isDebt: isDebt,
        dateFrom: this.searchParams.monthRange
          ? this.$moment
              .utc(this.searchParams.monthRange)
              ?.add(1, 'days')
              ?.format('YYYY-MM-DD')
          : null,
        dateTo: this.searchParams.monthRange
          ? this.$moment
              .utc(this.searchParams.monthRange)
              ?.add(1, 'days')
              ?.endOf('month')
              ?.format('YYYY-MM-DD')
          : null
      })
      return res.data
    },
    async getAgentById(id) {
      const res = await getAgentByIdApi({ id: id })
      this.agent = res.data
      this.agentName = this.agent?.name
    },
    async fnGetDebtDetailReport() {
      try {
        const query = {
          dateFrom: this.searchParams.monthRange
            ? this.$moment
                .utc(this.searchParams.monthRange)
                ?.add(1, 'days')
                ?.format('YYYY-MM-DD')
            : null,
          dateTo: this.searchParams.monthRange
            ? this.$moment
                .utc(this.searchParams.monthRange)
                ?.add(1, 'days')
                ?.endOf('month')
                ?.format('YYYY-MM-DD')
            : null,
          // hotelIdList: this.searchParams.hotelIdList,
          agentId: this.searchParams.agentId
        }
        const res = await getDebtDetailReport(query)
        this.rows = res.data
          .map(item => {
            if (item?.detail.length > 0) {
              // const list = item?.detail
              // list[0].row_class = 'firstRow'
              // list[0].count_rows = list.length
              // list[0].recode = item.recode
              // list[0].date = item.date
              // return list
              const list = item?.detail?.map((subItem, index) => {
                if (index === 0) {
                  subItem.row_class = 'firstRow'
                  subItem.count_rows = item?.detail.length
                  subItem.recode = item.recode
                }
                item?.sub_booking_group_id
                  ? (subItem.subBookingId = item?.sub_booking_group_id)
                  : false
                subItem.date = item.date
                return subItem
              })
              return list
            } else {
              return [item]
            }
          })
          .reduce((pre, cur) => {
            return pre?.concat(cur)
          }, [])
        this.pinnedBottomRowData = [
          {
            invoice_num: 'Tổng',
            increase: res.map.total_increase,
            decrease: res.map.total_decrease,
            arising_not_deducted: res.map.total_arising_not_deducted,
            debt: res.map.total_reduce
          }
        ]

        this.decreaseRows = res.map.decrease
        this.selectedRows = []

        this.monthFrom = this.searchParams.monthRange
          ? this.$moment
              .utc(this.searchParams.monthRange)
              ?.add(1, 'days')
              ?.format('MM/YYYY')
          : null
        this.monthTo = this.searchParams.monthRange
          ? this.$moment
              .utc(this.searchParams.monthRange)
              ?.add(1, 'days')
              ?.endOf('month')
              ?.format('MM/YYYY')
          : null
        this.agentName = this.agent?.name
      } catch (error) {
        console.error(error)
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },
    async downloadExcel() {
      try {
        const query = {
          dateFrom: this.searchParams.monthRange
            ? this.$moment
                .utc(this.searchParams.monthRange)
                ?.add(1, 'days')
                ?.format('YYYY-MM-DD')
            : null,
          dateTo: this.searchParams.monthRange
            ? this.$moment
                .utc(this.searchParams.monthRange)
                ?.add(1, 'days')
                ?.endOf('month')
                ?.format('YYYY-MM-DD')
            : null,
          agentId: this.searchParams.agentId
        }
        const res = await getDebtDetailReportExcel(query)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(res, 'bao_cao_chi_tiet_cong_no_' + date + '.xlsx')
      } catch (error) {
        console.error(error)
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    }
  }
}
</script>
<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
